import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../../components/buttons/PrimaryButton";
import { SecondaryButton } from "../../components/buttons/SecondaryButton";
import Form from "../../components/inputs/Form";
import Header from "../../components/layout/Header";
import { Page, PageBody, PageHeader } from "../../components/layout/Page";
import { backArrow, save } from "../../assets/icons";
import Card from "../../components/card/Card";
import "./device.css";
import { TextInput } from "../../components/inputs/TextInput";
import { useState } from "react";
import { Data, SetState } from "../../lib/typeDeclarations";
import { pattern } from "../../lib/pattern";
import { createRecord } from "../../server/fetchFunctions";
import { Autocomplete } from "../../components/inputs/Autocomplete";
import { useListRecords } from "../../server/hooks/getData";

export default function NewDevice() {
  document.title = "Új eszköz";
  const navigate = useNavigate();

  const [device, setDevice] = useState<Data>({
    type: "",
    description: "",
    description_id: "",
    manufacturer: "",
    manufacturer_id: "",
    cal_price: "",
  });

  const manufacturers = useListRecords("devManu", [device.manufacturer], {
    manufacturer: device.manufacturer,
    limit: 10,
  });
  const descriptions = useListRecords("devDesc", [device.description], {
    description: device.description,
    limit: 10,
  });

  //Functions
  const handleAutoClompleteManu = (item: Data) => {
    setDevice((prev) => ({ ...prev, manufacturer: item.manufacturer, manufacturer_id: item.id }));
  };

  const handleAutoClompleteDesc = (item: Data) => {
    setDevice((prev) => ({ ...prev, description: item.description, description_id: item.id }));
  };

  const saveDevice = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    let newDevice = device;

    if (!device.manufacturer_id) {
      const response = await createRecord("devManu", { manufacturer: device.manufacturer });
      newDevice = { ...newDevice, manufacturer_id: response.id };
    }

    if (!device.description_id) {
      const response = await createRecord("devDesc", { description: device.description });
      newDevice = { ...newDevice, description_id: response.id };
    }

    const response = await createRecord("devices", newDevice);
    navigate(`/devices/${response.id}`);
  };

  return (
    <Page>
      <Form onSubmit={(e) => saveDevice(e)}>
        <Header>
          <SecondaryButton btn={{ svgBefore: backArrow, text: "Vissza", onClick: () => navigate(-1) }} />
          <PrimaryButton btn={{ svgBefore: save, text: "Ment", onClick: () => navigate(-1) }} />
        </Header>
        <PageHeader title="Új eszköz rögzítése" />
        <PageBody>
          <div className="device">
            <div className="col-1">
              <Card title="Eszköz">
                <TextInput
                  stateKey="type"
                  inlineLabel="Típus"
                  state={device}
                  setState={setDevice}
                  pattern={pattern.normal_text}
                  labelWidth={170}
                  required
                />

                <Autocomplete
                  inlineLabel="Gyártó"
                  stateKey="manufacturer"
                  state={device}
                  setState={setDevice}
                  list={manufacturers.data.data}
                  listKeys={["manufacturer"]}
                  handleClick={handleAutoClompleteManu}
                  pattern={pattern.normal_text}
                  labelWidth={170}
                  required
                />

                <Autocomplete
                  inlineLabel="Megnevezés"
                  stateKey="description"
                  state={device}
                  setState={setDevice}
                  list={descriptions.data.data}
                  listKeys={["description"]}
                  handleClick={handleAutoClompleteDesc}
                  pattern={pattern.normal_text}
                  labelWidth={170}
                  required
                />

                <TextInput
                  stateKey="cal_price"
                  inlineLabel="Kalibrálási költség"
                  state={device}
                  setState={setDevice}
                  afterText="Ft"
                  pattern={pattern.normal_text}
                  labelWidth={170}
                />
              </Card>
            </div>
          </div>
        </PageBody>
      </Form>
    </Page>
  );
}
